import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import Background from "../../assets/headerGalvanisPhone.jpg";
import FotoHeader from "../../assets/coilAbuProducts.jpeg";

const StockAdmin = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* APLIKASI PC */}
      <section className="hidden sm:block">
        <h1 className="text-4xl container-screen text-primaryPandawa font-helvetica text-left">
          STOCK ADMINISTRASI
        </h1>
        <h2 className="container-screen text-left text-bold text-2xl text-gray-500">
          (Inventory Admin)
        </h2>
        <section className="container-screen grid grid-cols-5 py-10">
          <div className="col-span-5">
            <div>
              <div className="text-left">
                <div>
                  <div className="flex items-center gap-2">
                    <h2 className="font-helvetica font-bold ">
                      Job Description
                    </h2>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <ul className="list-disc list-outside pl-5 space-y-2 text-gray-700 text-left">
                  <li className="font-montserrat">
                    Memantau inventarisasi rutin dan audit stok untuk memastikan
                    akurasi dan ketersediaan stok barang di gudang.
                  </li>
                  <li className="font-montserrat">
                    Mengembangkan dan menerapkan SOP Warehouse untuk
                    meningkatkan efisiensi.
                  </li>
                  <li className="font-montserrat">
                    Memastikan barang masuk dan keluar sesuai dokumen (DO,
                    faktur, PO) dan sistem inventory.
                  </li>
                  <li className="font-montserrat">
                    Menyusun sistem penyimpanan barang yang rapi, efisien, dan
                    sesuai kategori.
                  </li>
                  <li className="font-montserrat">
                    Bekerja sama dengan tim purchasing dan sales untuk
                    memastikan ketersediaan stok.
                  </li>
                  <li className="font-montserrat">
                    Berkomunikasi dan mencari vendor transportasi dan logistik
                    untuk pengiriman barang.
                  </li>
                  <li className="font-montserrat">
                    Membuat proyeksi kebutuhan stok dan memastikan Reorder Point
                    (ROP) selalu tersedia dengan akurat, tanpa kekurangan atau
                    kesalahan.
                  </li>
                  <li className="font-montserrat">
                    Membuat laporan bulanan terkait pergerakan stok,
                    ketersediaan barang, dan potensi deadstock.
                  </li>
                  <li className="font-montserrat">
                    Melakukan pengawasan terhadap FIFO/FEFO dan sistem
                    keluar-masuk barang yang tepat.
                  </li>
                  <li className="font-montserrat">
                    Memastikan pencatatan inventory terlaksana dengan tepat dan
                    benar
                  </li>
                </ul>
              </div>

              <div className="text-left mt-10">
                <div className="flex items-center gap-2">
                  <h2 className="font-helvetica font-bold ">Kualifikasi</h2>
                </div>
              </div>

              <div className="mt-4">
                <ul className="list-disc list-outside pl-5 space-y-2 text-gray-700 text-left">
                  <li className="font-montserrat">
                    Pendidikan minimal D3 dari jurusan yang relevan.
                  </li>
                  <li className="font-montserrat">
                    Menguasai Ms. Excel terutama Pivot Table, Vlookup, Hlookup,
                    If
                  </li>
                  <li className="font-montserrat">
                    Memiliki minimal 4 tahun pengalaman di bidang Inventory
                    Control dan Purchasing.
                  </li>
                  <li className="font-montserrat">
                    Memiliki minimal 2 tahun pengalaman dalam : Pengaturan
                    mapping gudang dan penerapan sistem FIFO.
                  </li>
                  <li className="font-montserrat">
                    Berpengalaman mengelola inventory dengan lebih dari 1000
                    SKU.
                  </li>
                  <li className="font-montserrat">
                    Mampu menjalankan Warehouse Management System (WMS) secara
                    administratif dan melakukan input data ke sistem.
                  </li>
                  <li className="font-montserrat">
                    Memiliki kemampuan analisis data yang efektif dan efisien.
                  </li>
                  <li className="font-montserrat">
                    Mampu melakukan quality check terhadap barang masuk dan
                    keluar.
                  </li>
                  <li className="font-montserrat">
                    Terbiasa menyelesaikan pekerjaan dan target harian (closing
                    harian) sebelum pulang.
                  </li>
                  <li className="font-montserrat">
                    Mampu bekerja dalam tekanan dan siap dengan target kerja
                    tinggi.
                  </li>
                  <li className="font-montserrat">
                    Memiliki kemampuan komunikasi dan adaptasi yang baik, baik
                    dengan tim internal maupun pihak eksternal.
                  </li>
                  <li className="font-montserrat">
                    Mampu bekerja secara tim dan memiliki integritas tinggi.
                  </li>
                  <li className="font-montserrat">
                    Siap bekerja lembur atau pulang malam jika volume pekerjaan
                    tinggi.
                  </li>
                  <li className="font-montserrat">
                    Pekerja keras, disiplin, dan bertanggung jawab.
                  </li>
                  <li className="font-montserrat">
                    Pengalaman mengoperasikan fitur pembelian dan fitur gudang
                    di Accurate Online akan menjadi nilai tambah.
                  </li>
                  <li className="font-montserrat">
                    Usia minimal 22 tahun dan maksimal 40 tahun.
                  </li>
                </ul>
              </div>

              <div className="text-left mt-10">
                <div className="flex items-center gap-2">
                  <h2 className="font-helvetica font-bold ">
                    Keterampilan Lain
                  </h2>
                </div>
              </div>

              <div className="mt-4">
                <ul className="list-disc list-outside pl-5 space-y-2 text-gray-700 text-left">
                  <li className="font-montserrat">
                    Teliti, detail, dan rapi dalam administrasi.
                  </li>
                  <li className="font-montserrat">
                    Mampu bekerja secara tim maupun mandiri.
                  </li>
                  <li className="font-montserrat">
                    Memiliki kemampuan komunikasi dan koordinasi yang baik.
                  </li>
                  <li className="font-montserrat">
                    Jujur, bertanggung jawab, dan memiliki integritas tinggi.
                  </li>
                </ul>
              </div>

              <div className="text-left mt-10">
                <div className="flex items-center gap-2">
                  <h2 className="font-helvetica font-bold ">Kondisi Kerja</h2>
                </div>
              </div>

              <div className="mt-4">
                <ul className="list-disc list-outside pl-5 space-y-2 text-gray-700 text-left">
                  <li className="font-montserrat">
                    Bersedia bekerja lembur jika dibutuhkan, terutama saat stock
                    opname.
                  </li>
                </ul>
              </div>
              <div className="lg:mt-10 flex justify-start">
                <button
                  onClick={() =>
                    window.open(
                      "https://mail.google.com/mail/?view=cm&fs=1&to=Hr@pandawajayasteel.co.id&su=Lamaran%20Kerja%20-%20Stock%20Admin&body=Halo%2C%20saya%20ingin%20melamar%20untuk%20posisi%20Stock%20Admin",
                      "_blank"
                    )
                  }
                  className="bg-primaryPandawa hover:bg-primaryPandawa/90 transition duration-300 px-6 py-3 rounded-lg shadow-md text-white font-semibold"
                >
                  Lamar Sekarang
                </button>
              </div>
              <p className="text-left text-xs mt-2 text-gray-500">
                *Jika terdapat kendala silahkan lampirkan CV secara manual ke
                hr@pandawajayasteel.co.id
              </p>
            </div>
          </div>
          {/* <div className="col-span-2 rounded-lg overflow-hidden ml-auto h-full w-3/4">
            <img src={Background} className="h-full" alt="Background" />
          </div> */}
        </section>
      </section>

      {/* MOBILE VERSION */}
      {/* MOBILE VERSION */}
      {/* MOBILE VERSION */}
      <section className="sm:hidden bg-white py-8">
        <div className="container-screen text-left">
          <h1 className="font-helvetica text-primaryPandawa text-left text-2xl mb-6 font-bold">
            STOCK ADMINISTRASI
          </h1>

          {/* Job Description */}
          <div className="mb-8">
            <h2 className="font-helvetica font-bold text-lg mb-3 text-primaryPandawa">
              Job Description
            </h2>
            <ul className="list-disc list-outside pl-5 space-y-2 text-gray-800 text-sm">
              <li>
                Memantau inventarisasi rutin dan audit stok untuk memastikan
                akurasi dan ketersediaan stok barang di gudang.
              </li>
              <li>
                Mengembangkan dan menerapkan SOP Warehouse untuk meningkatkan
                efisiensi.
              </li>
              <li>
                Memastikan barang masuk dan keluar sesuai dokumen (DO, faktur,
                PO) dan sistem inventory.
              </li>
              <li>
                Menyusun sistem penyimpanan barang yang rapi, efisien, dan
                sesuai kategori.
              </li>
              <li>
                Bekerja sama dengan tim purchasing dan sales untuk memastikan
                ketersediaan stok.
              </li>
              <li>
                Berkomunikasi dan mencari vendor transportasi dan logistik untuk
                pengiriman barang.
              </li>
              <li>
                Membuat proyeksi kebutuhan stok dan memastikan Reorder Point
                (ROP) selalu tersedia dengan akurat, tanpa kekurangan atau
                kesalahan.
              </li>
              <li>
                Membuat laporan bulanan terkait pergerakan stok, ketersediaan
                barang, dan potensi deadstock.
              </li>
              <li>
                Melakukan pengawasan terhadap FIFO/FEFO dan sistem keluar-masuk
                barang yang tepat.
              </li>
              <li>
                Memastikan pencatatan inventory terlaksana dengan tepat dan
                benar.
              </li>
            </ul>
          </div>

          {/* Kualifikasi */}
          <div className="mb-8">
            <h2 className="font-helvetica font-bold text-lg mb-3 text-primaryPandawa">
              Kualifikasi
            </h2>
            <ul className="list-disc list-outside pl-5 space-y-2 text-gray-800 text-sm">
              <li>Pendidikan minimal D3 dari jurusan yang relevan.</li>
              <li>
                Menguasai Ms. Excel terutama Pivot Table, Vlookup, Hlookup, If.
              </li>
              <li>
                Memiliki minimal 4 tahun pengalaman di bidang Inventory Control
                dan Purchasing.
              </li>
              <li>
                Memiliki minimal 2 tahun pengalaman dalam: Pengaturan mapping
                gudang dan penerapan sistem FIFO.
              </li>
              <li>
                Berpengalaman mengelola inventory dengan lebih dari 1000 SKU.
              </li>
              <li>
                Mampu menjalankan Warehouse Management System (WMS) secara
                administratif dan melakukan input data ke sistem.
              </li>
              <li>
                Memiliki kemampuan analisis data yang efektif dan efisien.
              </li>
              <li>
                Mampu melakukan quality check terhadap barang masuk dan keluar.
              </li>
              <li>
                Terbiasa menyelesaikan pekerjaan dan target harian (closing
                harian) sebelum pulang.
              </li>
              <li>
                Mampu bekerja dalam tekanan dan siap dengan target kerja tinggi.
              </li>
              <li>
                Memiliki kemampuan komunikasi dan adaptasi yang baik, baik
                dengan tim internal maupun pihak eksternal.
              </li>
              <li>Mampu bekerja secara tim dan memiliki integritas tinggi.</li>
              <li>
                Siap bekerja lembur atau pulang malam jika volume pekerjaan
                tinggi.
              </li>
              <li>Pekerja keras, disiplin, dan bertanggung jawab.</li>
              <li>
                Pengalaman mengoperasikan fitur pembelian dan fitur gudang di
                Accurate Online akan menjadi nilai tambah.
              </li>
              <li>Usia minimal 22 tahun dan maksimal 40 tahun.</li>
            </ul>
          </div>

          {/* Keterampilan Lain */}
          <div className="mb-8">
            <h2 className="font-helvetica font-bold text-lg mb-3 text-primaryPandawa">
              Keterampilan Lain
            </h2>
            <ul className="list-disc list-outside pl-5 space-y-2 text-gray-800 text-sm">
              <li>Teliti, detail, dan rapi dalam administrasi.</li>
              <li>Mampu bekerja secara tim maupun mandiri.</li>
              <li>Memiliki kemampuan komunikasi dan koordinasi yang baik.</li>
              <li>Jujur, bertanggung jawab, dan memiliki integritas tinggi.</li>
            </ul>
          </div>

          {/* Kondisi Kerja */}
          <div className="mb-8">
            <h2 className="font-helvetica font-bold text-lg mb-3 text-primaryPandawa">
              Kondisi Kerja
            </h2>
            <ul className="list-disc list-outside pl-5 space-y-2 text-gray-800 text-sm">
              <li>
                Bersedia bekerja lembur jika dibutuhkan, terutama saat stock
                opname.
              </li>
            </ul>
          </div>

          {/* Tombol Lamar */}
          <div className="text-center mt-8 w-full">
            <button
              onClick={() =>
                (window.location.href =
                  "mailto:hr@pandawajayasteel.co.id?subject=Lamar%20Pekerjaan%20-%20Stock%20Administrator")
              }
              className="bg-primaryPandawa hover:bg-primaryPandawa/90 transition duration-300 px-6 py-3 rounded-lg shadow-md text-white font-semibold w-full"
            >
              Lamar Sekarang
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default StockAdmin;
